export default "__VITE_ASSET__CAsSN2UU__"